



















































































import { fetchJson } from '@padlet/fetch'
import { Component, Watch, Prop, Mixins } from 'vue-property-decorator'
import type { ImageSearchResult, SearchFilters } from 'bits/web_search'
import { getHostname } from 'bits/url'
import BaseIcon from 'vuecomponents/base_icon.vue'
import ImageThumbnail from 'library/v4/components/image-thumbnail.vue'
import { IntlMixin } from 'vuemixins/intl_mixin'
@Component({ components: { BaseIcon, ImageThumbnail } })
export default class ContentPickerSearchResultsImage extends Mixins(IntlMixin) {
  $refs!: { container: HTMLUListElement; imageWrappers: HTMLDivElement[] }
  imageWidth = 0
  @Prop() results!: ImageSearchResult[]
  @Prop() filter!: SearchFilters
  LOADING_IMAGES_BG_COLOR = ['red', 'blue', 'green', 'yellow', 'purple', 'pink', 'cyan', 'orange']

  @Watch('results')
  handleResultsUpdate(): void {
    this.$nextTick(() => {
      this.imageWidth =
        this.$refs.imageWrappers && this.$refs.imageWrappers[0] && this.$refs.imageWrappers[0].clientWidth
    })
  }

  selectWithBeacon(url: string, beaconLink: string): void {
    if (beaconLink) {
      fetchJson(beaconLink, { cors: true })
    }
    this.$emit('select', url)
  }

  providerName(result: ImageSearchResult): string {
    if (result.provider_name) return result.provider_name
    return getHostname(result.url)
  }

  mounted(): void {
    this.imageWidth = this.$refs.container.clientWidth / 3 - 12
    // After the components are auto-layouted, we assigned the fixed imageWidth so that
    // Beethoven-Vivaldi can load the most size-optimal image
    this.handleResultsUpdate()
  }
}
